import {gsap} from 'gsap';
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const mm = gsap.matchMedia();
      mm.add( '(max-width: 1023px)', () => {
        setupTabs( true );
      } );

      mm.add( '(min-width: 1024px)', () => {
        setupTabs();
      } );

      function setupTabs( mobile = false ) {
        $( '.storytelling-tabs' ).each( function( key, component ) {
          let topOffset = $( '.navbar' ).outerHeight();
          let $panels = $( '.storytelling-tabs__panel' );

          if ( mobile ) {
            $panels = $( '.storytelling-tabs__panel:not(.is-desktop)' );
          }

          const count = $panels.length;
          let lastIndex = -1;
          const panelHeight = $( component ).find( '.storytelling-tabs__panel' ).outerHeight();
          const pinnedAmount = ( panelHeight * count ) * 2;

          if ( $( '#wpadminbar' ).length ) {
            topOffset += $( '#wpadminbar' ).outerHeight();
          }

          const pinner = gsap.timeline( {
            scrollTrigger: {
              trigger: $( component ).find( '.storytelling-tabs__desktop' )[0],
              pin: true,
              start: 'top ' + topOffset,
              end: '+=' + pinnedAmount,
              onUpdate: function( e ) {
                const adjustedProgress = e.progress;
                let index = Math.floor( adjustedProgress * count );
                if ( index >= count ) index = count - 1;

                // if ( index === lastIndex ) return;

                $panels.removeClass( 'is-active' );
                $panels.eq( index ).addClass( 'is-active' );
                lastIndex = index;
              },
              scrub: 2,
            },
          } );

          $( component ).find( '.storytelling-tabs__scroller' ).on( 'click', function() {
            $( 'html, body' ).animate( {
              scrollTop: $( component ).offset().top + ( panelHeight * 1 ),
            }, 1000 );

            setTimeout( function() {
              $( component ).find( '.storytelling-tabs__step--1.storytelling-tabs__panel--1' ).attr( 'tabindex', '0' ).trigger( 'focus' ).removeAttr( 'tabindex' );
            }, 2000 );
          } );

          $( component ).find( '.storytelling-tabs__tab' ).on( 'click', function() {
            const index = $( $( this ).attr( 'data-step' ) ).index();
            $( '.storytelling-tabs__panel' ).addClass( 'is-skipping' );
            $( '.storytelling-tabs__step--loading' ).addClass( 'is-active' );

            $( 'html, body' ).animate( {
              scrollTop: $( component ).offset().top + ( ( panelHeight * 2 ) * index ),
            }, 1000 );

            setTimeout( function() {
              $( '.storytelling-tabs__panel' ).removeClass( 'is-skipping' );
              $( '.storytelling-tabs__step--loading' ).removeClass( 'is-active' );
            }, 1000 );

            setTimeout( function() {
              $( component ).find( '.storytelling-tabs__panel--' + ( index ) ).attr( 'tabindex', '0' ).trigger( 'focus' ).removeAttr( 'tabindex' );
            }, 2000 );
          } );

          $( component ).find( '.storytelling-tabs__step-2__tab' ).on( 'click', function() {
            const index = $( $( this ).attr( 'data-panel' ) ).index();
            console.log( index );
            if ( index == 3 ) {
              $( 'html, body' ).animate( {
                scrollTop: $( component ).offset().top + ( panelHeight * 4 ) + ( panelHeight * index ),
              }, 500 );
            } else {
              $( 'html, body' ).animate( {
                scrollTop: $( component ).offset().top + ( panelHeight * 5 ) + ( panelHeight * index ),
              }, 500 );
            }

            setTimeout( function() {
              $( component ).find( '.storytelling-tabs__panel--' + ( index ) ).attr( 'tabindex', '0' ).trigger( 'focus' ).removeAttr( 'tabindex' );
            }, 500 );
          } );
        } );
      }

      $( '.storytelling-tabs' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--storytelling-tabs' )[0], {
          pagination: false,
          arrows: true,
          perPage: 1,
          perMove: 1,
          gap: '32px',
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'storytelling-tabs', COMPONENT );
} )( app );
